module.exports = {
	"no": {
		"hqm": {
			"support-button": "Få støtte",
			"support-page": {
				"create-ticket": {
					"title": "Få støtte",
					"instructions": "Send inn en forespørsel nedenfor, så kommer vi tilbake til deg.",
					"fields": {
						"mid": {
							"label": "Velg butikk",
							"validation": "Butikk kreves"
						},
						"topic": {
							"question": "Hva er spørsmålet ditt relatert til?",
							"label": "Velg et emne",
							"validation": "Emne kreves",
							"options": {
								"orders": "Ordrer",
								"settlements": "Oppgjør",
								"agreements": "Avtaler",
								"technical_issues": "Tekniske problemer",
								"others": "Andre"
							}
						},
						"subject": {
							"label": "Emne",
							"validation": "Tema kreves"
						},
						"description": {
							"label": "Beskjed",
							"validation": "Beskrivelse kreves"
						},
						"attachment": {
							"label": "Legg til vedlegg",
							"button": "Last opp",
							"info": "Å legge til skjermbilder vil hjelpe oss med å løse problemet raskere.",
							"supportedFileTypes": "Støttede filtyper: .png, .jpg, .pdf",
							"error": "Total filstørrelse kan ikke overstige 15 MB"
						}
					},
					"submit": "Send inn forespørsel",
					"service-unavailable-error": "Au da! Noe gikk galt, prøv igjen om noen minutter. Hvis problemet vedvarer, {link} for hjelp.",
					"contact-page-link": "kontakt oss"
				},
				"view-ticket": {
					"title": "Ferdig!",
					"details": "Vi har mottatt forespørselen din, og du vil få svar snart. Her er detaljene dine:",
					"ticket": "Be om #{ticketId}",
					"email": "E-post: {email}",
					"status": "Du kan spore statusen på supportsiden vår.",
					"track": "Spor status"
				}
			},
			"popup": {
				"yes": "Ja",
				"no": "Nei",
				"somethingElse": "Jeg trenger hjelp med noe annet"
			},
			"header": {
				"homeLink": "Tilbakestill"
			},
			"home": {
				"greeting": "Hei {givenName}! Hvordan kan vi hjelpe deg?",
				"topics": "Hva trenger du hjelp med?"
			},
			"topics": {
				"expandButton": "Mer"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Vi beklager at dette ikke hjalp. Kanskje noen av disse artiklene kan hjelpe deg?",
				"stillQuestionsTitle": "Har du fortsatt spørsmål?",
				"stillQuestionsParagraph": "Du kan også kontakte oss direkte.",
				"contactButton": "Kontakt oss"
			},
			"feedback": {
				"title": "Var dette til hjelp?",
				"optionYes": "Ja, dette var nyttig",
				"optionNo": "Nei, jeg trenger mer hjelp",
				"positiveFeedback": "Takk for positiv tilbakemelding, dette hjelper oss med å gi deg mer relevante artikler i fremtiden."
			},
			"freeTextFeedback": {
				"title": "Hjelp oss å bli bedre",
				"placeholder": "Hvorfor synes du ikke at dette innholdet var nyttig?",
				"submitButton": "Send",
				"feedbackMessage": "Takk for din tilbakemelding, dette hjelper oss med å gi deg mer relevante artikler i fremtiden."
			},
			"relatedContent": {
				"title": "Relatert innhold"
			},
			"search": {
				"buttonLabel": "Søk",
				"input": "Søk etter artikler ...",
				"loading": "Laster inn ...",
				"results": {
					"contact": "Finner du ikke hjelpen du trenger?",
					"empty": "Beklager, vi fant ingen resultater for søket ditt. Prøv å søke etter et annet begrep.",
					"singleTopicFound": "Vi fant 1 emne",
					"multipleTopicsFound": "Vi fant {count} emner",
					"singleArticleFound": "Vi fant 1 artikkel",
					"multipleArticlesFound": "Vi fant {count} artikler"
				}
			},
			"contact": {
				"title": "Kontakt oss",
				"channelsIntro": "Kontakt oss slik at vi kan hjelpe deg.",
				"businessDetailsTitle": "Forretningsinformasjonen din",
				"businessDetailsName": "Firmanavn",
				"businessDetailsEmail": "E-post",
				"businessDetailsMid": "Butikk-ID",
				"phone": {
					"title": "Ring oss",
					"paragraph": "Du kan ringe oss i arbeidstiden på hverdager. Hvis du befinner deg i Sverige eller Storbritannia, kan du også ringe oss i helgen mellom kl. 10.00 og 16.00."
				},
				"chat": {
					"title": "Chat med oss",
					"paragraph": "Den raskeste og enkleste måten å nå Support. Chatten vår er åpen.",
					"button": "Åpne Chat"
				},
				"email": {
					"title": "Send oss en e-post",
					"paragraph": "Send oss en e-post, så kommer vi tilbake til deg så snart vi kan."
				}
			},
			"errorBoundary": {
				"title": "Noe gikk galt",
				"message": "Vi beklager, men det oppstod en feil. Du kan klikke på knappen nedenfor for å tilbakestille og lukke dette sidefeltet.",
				"resetButton": "Tilbakestill",
				"errorId": "Feil-ID: {errorId}"
			},
			"tour": {
				"prev": "Forrige",
				"next": "Neste",
				"done": "Ferdig"
			},
			"notAvailableMobile": {
				"title": "Ikke tilgjengelig",
				"buttonBack": "Tilbake",
				"paragraph": "Dette innholdet er ikke tilgjengelig på enheten din. Prøv å åpne på en enhet med større skjermstørrelse, for eksempel en stasjonær datamaskin."
			},
			"shareButton": {
				"title": {
					"article": "Del en dyp lenke til denne artikkelen",
					"topic": "Del en dyp lenke til dette emnet",
					"tour": "Del en dyp lenke til denne turen"
				},
				"radioItemHome": "Hjem-app",
				"descriptionHome": "Åpner hjelpeartikkelen på Merchant Portal-hjemmesiden",
				"radioItemCurrent": "Nåværende side",
				"descriptionCurrent": "Åpner hjelpeartikkel på gjeldende side"
			}
		},
		"orientation": {
			"title": "Lær hvordan man lager ..."
		},
		"core": {
			"alert": {
				"message": "Noe gikk galt. Vennligst prøv igjen.",
				"correlationIdLabel": "Korrelasjons-ID:"
			},
			"header": {
				"title": "Merchant Portal"
			},
			"usermenu": {
				"language": "Språk",
				"country": "Land",
				"timezone": "Tidssone",
				"logout": "Logg ut",
				"profile": "Profil",
				"changeProfile": "Endre",
				"tooltip": "Din profil"
			},
			"appsmenu": {
				"defaultTooltip": "Dine apper",
				"initialTooltip": "Finn dine apper her.",
				"newAppsTooltip": "Vi har nye apper til deg!"
			},
			"helpful-question-mark": {
				"helpLabel": "Hjelp"
			},
			"languages": {
				"da": "Dansk",
				"de": "Tysk",
				"en": "Engelsk",
				"en_GB": "Engelsk (GB)",
				"en_US": "Engelsk (US)",
				"es": "Spansk",
				"fi": "Finsk",
				"fr": "Fransk",
				"it": "Italiensk",
				"nl": "Nederlandsk",
				"no": "Norsk",
				"sv": "Svensk"
			},
			"countries": {
				"de": "Tyskland",
				"dk": "Danmark",
				"fi": "Finland",
				"gb": "Storbritannia",
				"nl": "Nederland",
				"no": "Norge",
				"se": "Sverige",
				"us": "USA"
			},
			"selectLanguage": {
				"title": "Velg språk",
				"paragraph": "Dette vil være ditt standardspråk",
				"submit": "OK"
			},
			"selectCountry": {
				"title": "Velg land",
				"paragraph": "Dette vil være ditt standardland.",
				"submit": "OK"
			},
			"updateProfile": {
				"title": "Oppdater detaljer",
				"submit": "OK",
				"emailLabel": "E-postadresse",
				"firstNameLabel": "Fornavn",
				"lastNameLabel": "Etternavn",
				"resetPasswordLabel": "Sett opp passord på nytt",
				"resetPasswordSuccessLabel": "E-post om tilbakestilling av passord er sent",
				"resetPasswordErrorLabel": "Feil under sending av e-post om tilbakestilling av passord",
				"error": "Detaljoppdatering feilet"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Alle rettigheter reservert.",
					"oc": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215"
				},
				"terms": "Betingelser og vilkår"
			},
			"accessDenied": {
				"title": "Du trenger mer tilgang for denne siden.",
				"message": "Kontakt din administrator eller Klarna dersom du har spørsmål."
			},
			"midSelector": {
				"label": "Butikk"
			},
			"storeSelector": {
				"label": "Butikk"
			},
			"storesSelector": {
				"closeText": "Ferdig",
				"closeTextWithSelection": "Bruk # valg",
				"deselectAllOptionText": "Fjern markeringen",
				"emptyStateText": "Ingen butikker funnet",
				"label": "Butikker",
				"searchFieldLabel": "Søk etter butikk",
				"selectAllOptionText": "Velg alle butikker",
				"selectedAllText": "Alle butikker",
				"selectedText": "# butikker"
			},
			"pagination": {
				"ofLabel": "av",
				"noResultsLabel": "Ingen resultat"
			},
			"dateRangePicker": {
				"startLabel": "Startdato ",
				"endLabel": "Sluttdato",
				"months": {
					"january": "Januar",
					"february": "Februar",
					"march": "Mars",
					"april": "April",
					"may": "Mai",
					"june": "Juni",
					"july": "Juli",
					"august": "August",
					"september": "September",
					"october": "Oktober",
					"november": "November",
					"december": "Desember"
				},
				"weekDaysShort": {
					"monday": "M",
					"tuesday": "T",
					"wednesday": "O",
					"thursday": "T",
					"friday": "F",
					"saturday": "S",
					"sunday": "S"
				}
			},
			"appIcon": {
				"newLabel": "NYHET"
			},
			"appCategory": {
				"dayToDay": "For det daglige",
				"nko": "Klarna på nett",
				"tools": "Verktøy",
				"preferences": "Preferanser"
			},
			"apps": {
				"home-fe": {
					"title": "Hjem"
				},
				"nko-app": {
					"title": "Klarna Online apper"
				},
				"orders-fe": {
					"title": "Ordrer",
					"description": "Søk opp og administrer ordre fra Klarna.",
					"nkoLinkText": "Få tilgang til tidligere ordre"
				},
				"nko-orders": {
					"title": "Ordre (KO)",
					"description": "Søk etter og administrer bestillingene dine gjennom Klarna Online."
				},
				"settlements-fe": {
					"title": "Oppgjør",
					"description": "Se transaksjonene dine og generer rapporter for avstemming.",
					"nkoLinkText": "Få tilgang til tidligere rapporter"
				},
				"nko-settlements": {
					"title": "Oppgjør (KO)",
					"description": "Finn rapporter om bestillinger og utbetalinger fra Klarna Online."
				},
				"logs-app-fe": {
					"title": "Logger",
					"description": "Søk i API-logger for å feilsøke integrasjonsproblemer."
				},
				"users-fe": {
					"title": "Brukere",
					"description": "Inviter nye brukere og administrer eksisterende brukere i portalen."
				},
				"settings-fe": {
					"title": "Innstillinger",
					"description": "Be om Klarna API-legitimasjonene dine og administrer butikkinnstillinger."
				},
				"nko-settings": {
					"title": "Innstillinger (KO)",
					"description": "Administrer butikkinnstillingene, rapportene og kontaktinformasjonene."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Opprett nye ordrer med Klarnas løsning i butikk."
				},
				"products-fe": {
					"title": "Produkter",
					"description": "Guider deg på vei for å få mest mulig ut av Klarna."
				},
				"upstream-fe": {
					"title": "Meldinger på siden",
					"description": "Selg mer med skreddersydde og personlige finansieringstilbud."
				},
				"lending-fe": {
					"title": "Bedriftslån",
					"description": "Bedriftsfinansiering gjort enkelt"
				},
				"branding-fe": {
					"title": "Merkevarebygging",
					"description": "Ta kontroll over hvordan merkevaren din presenteres innad i Klarna."
				},
				"disputes-fe": {
					"title": "Tvister",
					"description": "Håndter dine tvister."
				},
				"logistics-fe": {
					"title": "Logistikk",
					"description": "Administrer all logistikk på ett sted."
				},
				"ob-transactions-fe": {
					"title": "Transaksjoner",
					"description": "Åpne banktransaksjoner"
				},
				"developers": {
					"title": "Utviklere"
				},
				"product-upgrade-fe": {
					"title": "Produktoppgradering"
				},
				"marketing": {
					"title": "Markedsføring",
					"description": "Finn markedsføringsressurser for å utvide virksomheten din her."
				},
				"business-card-fe": {
					"title": "Visittkort",
					"description": "Kommer snart"
				},
				"support": {
					"title": "Support",
					"description": "Sjekk og administrer supportforespørslene dine."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Tilbake"
				}
			},
			"errorBoundary": {
				"contact": "Prøv å oppdatere siden. {br}Hvis feilen vedvarer, kontakt <supportLink> Merchant Support</supportLink> og oppgi feil-ID-en {errorId}",
				"errorDescription": "Feil-ID - {errorId}",
				"reloadButton": "Oppdater",
				"title": "Det har dessverre oppstått en feil"
			},
			"maintenance": {
				"pageTitle": "Vedlikehold",
				"title": "Merchant Portal gjennomgår for tiden planlagt vedlikehold",
				"summary": "Vi er tilbake om litt",
				"scheduledSummary": "Vi er tilbake {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "En av de viktigste handelsdagene er rett rundt hjørnet. I løpet av Black Friday vil vi være her for å levere nærtidsstatistikk over salget ditt. I mellomtiden, la oss forberede oss på suksess!",
				"countdown": "Starter om #dd #ht #mm #ss…",
				"box1": {
					"title": "Kunder bruker 3,5 ganger mer*",
					"text": "I fjor brukte Klarna-kunder* i gjennomsnitt 3,5 ganger mer på Black Friday enn de gjorde noen annen dag i året.",
					"footnote": "*Gjennomsnitt for alle Klarnas forhandlerkategorier og -regioner."
				},
				"box2": {
					"title": "2,5 ganger større salgsvolum*",
					"text": "I fjor genererte Klarna-forhandlere 2,5 ganger så høyt salgsvolum på Black Friday enn noen annen dag i året.",
					"footnote": "*Gjennomsnitt for alle Klarnas forhandlerkategorier og -regioner."
				},
				"sectionTitle": "La oss øke Black Friday-salget ditt",
				"marketing": {
					"title": "Markedsfør virksomheten din før og på Black Friday",
					"text": "Driv flere kunder til butikken din i løpet av Black Friday med disse gratis markedsføringsressursene for sosiale medier og e-postkampanjer."
				},
				"branding": {
					"title": "Bli sett i Klarna-appen",
					"text": "12 millioner shoppere bruker Klarna-appen hver måned. Sørg for at du skinner i appen på Black Friday ved å legge til og oppdatere merkevareinformasjonen din her i forhandlerportalen."
				},
				"cta": "Kom i gang",
				"close": "Lukk"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Ordrevolum",
				"orderCountTitle": "Opprettede ordrer",
				"orderCount": "{count} ordrer",
				"box": {
					"title": "Vil du øke konverteringen ytterligere?",
					"subtitle1": "On-site messaging",
					"subtitle2": "Salgsfremmende og informative meldinger.",
					"text": "On-site messaging-verktøyet hjelper deg med å øke salget og gjennomsnittlige ordreverdier med salgsfremmende meldinger. La kundene få vite hvilke betalingsalternativ de har med én gang de kommer til nettstedet ditt og gjennom hele shoppingreisen.",
					"cta": "Kom i gang"
				},
				"selector": {
					"done": "Ferdig",
					"applySelection": "Bruk # valg",
					"selectAll": "Velg alle",
					"allOptions": "Alle muligheter er valgt",
					"someOptions": "# muligheter valgt",
					"storeMultiSelectLabel": "Velg # butikker",
					"allStores": "Alle butikker"
				},
				"currencyLabel": "Velg valuta",
				"storeLabel": "Velg butikk"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "Dette er omsetningen din fra en av årets viktigste shopping-uker.",
				"summaryTitle": "Oppsummering",
				"orderVolume": "Totalt volum",
				"orderCount": "Totalt antall ordrer",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "sammenlignet med samme dag, forrige uke",
				"tabs": {
					"monday": "Mandag",
					"tuesday": "Tirsdag",
					"wednesday": "Onsdag",
					"thursday": "Torsdag",
					"blackFriday": "Black Friday",
					"saturday": "Lørdag",
					"sunday": "Søndag",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};